const React = require('react');
const isNode = (typeof process !== 'undefined');
const Select = isNode ? require('react-select') : <div/>;
const Input = require('./../../FormComponents/Input');

class KopiAvLeie extends React.Component {
    constructor(props) {
        super(props);
        this.state = { confirmation: false };
    }
    getValues() {
        return {
            address: this.address.value,
            identityNumber: this.identityNumber.value,
            apartmentNumber: this.apartmentNumber.value,
            confirmation: this.state.confirmation,
            comment: this.comment.value,
        }
    }
    render() {
        const {hideHeaders, color} = this.props;

        return (
        <div className={`forms__inputContainer forms__inputContainer--${color}`}>
            {!hideHeaders && <h2 className="forms__formHeader">Kopi av leiekontrakt</h2>}
            <div className="forms__formElement">
                <Input validations="minLength:1" required name="address" type="text" placeholder="Adresse" ref={(address) => this.address = address}/>
            </div>
            <div className="forms__formElement">
                <Input validations="minLength:1" required name="identityNumber" type="text" placeholder="Fødselsnummer/organisasjonsnummer" ref={(identityNumber) => this.identityNumber = identityNumber}/>
            </div>
            <div className="forms__formElement">
                <Input name="apartmentNumber" type="text" placeholder="Leilighetsnummer" ref={(apartmentNumber) => this.apartmentNumber = apartmentNumber}/>
            </div>
            <div className="forms__formElement">
                <label><input type="checkbox" value={true} onChange={ev => this.setState({confirmation: ev.target.checked})}/> Jeg bekrefter med dette at jeg ønsker min kontrakt tilsendt (sendes ut per post)</label>
            </div>
            <div className="forms__formElement">
                <label className="form-label">Kommentar</label>
                <textarea placeholder="Kommentar" ref={(comment) => this.comment = comment}/>
            </div>
        </div>
        )
    }
}

module.exports = KopiAvLeie;



// WEBPACK FOOTER //
// ./src/main/resources/site/parts/Forms/forms/KopiAvLeie/index.jsx